import React from 'react';
import { Box, Section } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ContentSection = function ContentSection(_ref) {
  var main = _ref.main,
      aside = _ref.aside;
  return /*#__PURE__*/_jsxs(Section, {
    $styles: {
      display: ['block', 'flex'],
      alignItems: [undefined, 'stretch']
    },
    $withLastChildPadding: false,
    children: [/*#__PURE__*/_jsx(Box, {
      $styles: {
        width: [null, 644, 644, 644]
      },
      $mb: [82, null, null, null],
      $mr: [null, 115, 115, 115],
      children: main
    }), /*#__PURE__*/_jsx(Box, {
      $styles: {
        width: [null, 400, 400, 400]
      },
      children: aside
    })]
  });
};

export default ContentSection;